/**
 * BlogHeader Component
 *
 * Hero section for the blog listing page
 */

import { BookOpen, Search } from "lucide-react";

interface BlogHeaderProps {
  title?: string;
  description?: string;
  searchQuery?: string;
  onSearchChange?: (query: string) => void;
  showSearch?: boolean;
}

export function BlogHeader({
  title = "Builder Buddy Blog",
  description = "Expert tips, guides, and insights for Calgary builders, contractors, and homeowners",
  searchQuery = "",
  onSearchChange,
  showSearch = true,
}: BlogHeaderProps) {
  return (
    <div className="bg-gradient-to-br from-teal-500 to-cyan-600 text-white rounded-xl p-6 md:p-8 mb-8">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-12 h-12 rounded-xl bg-white/20 flex items-center justify-center">
          <BookOpen className="h-6 w-6" />
        </div>
        <div>
          <h1 className="text-2xl md:text-3xl font-bold">{title}</h1>
        </div>
      </div>
      <p className="text-teal-100 mb-6 max-w-2xl">{description}</p>

      {showSearch && onSearchChange && (
        <div className="max-w-md">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Search articles..."
              className="w-full pl-10 pr-4 py-2.5 rounded-lg bg-white text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-white/50"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default BlogHeader;
